
import { format } from 'date-fns';
import { logger } from './utils/logger';

class ApiSender {
  constructor() {
  }

  async sendPin(endpoint, msisdn, campaignId, language, trackerId, gclid, gbraid, wbraid, goalId, goalName, landingPageUrl, landingPageName, operatorId, yclid, clientId, userId) {
    const op = logger.startOperation(
      "send_otp",
      "sendPin",
      { msisdn, landingPageName, campaignId, trackerId },
      `Visitor clicked "Send OTP" for number ${msisdn} on "${landingPageName}"`
    );
    try {
      const date = new Date();
      const formattedDateTime = format(date, "yyyy-MM-dd HH:mm:ssxxx");
      const baseUrl = process.env.REACT_APP_SUB_BASE_URL;
      const response = await fetch(baseUrl + endpoint, {
        method: 'POST',
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          msisdn: msisdn,
          lang: language === 'RU' ? 'ru-RU' : 'uz-UZ',
          channel: 'LANDING_PAGE',
          campaignId: campaignId,
          trackerId: trackerId,
          gclid: gclid,
          gbraid: gbraid,
          wbraid: wbraid,
          conversionDateTime: formattedDateTime,
          conversionGoalId: goalId,
          conversionGoalName: goalName,
          landingPageUrl: landingPageUrl,
          landingPageName: landingPageName,
          operatorId: operatorId,
          yclid: yclid,
          clientId: clientId,
          userId: userId,
        })
      });

      if (response.ok) {
        const result = await response.json();
        if (result.status) {
          if (result.statusCode === 2003) {
            const data = result.data;
            op.success(`OTP send redirected (SMS) for ${msisdn}`, { statusCode: result.statusCode });
            return { success: true, message: result.message, redirectSms: data.redirectUr };
          }
          if (result.statusCode === 2004) {
            const data = result.data;
            op.success(`OTP send redirected (URL) for ${msisdn}`, { statusCode: result.statusCode });
            return { success: true, message: result.message, redirectUrl: data.url };
          }
          if (result.statusCode === 0) {
            op.success(`OTP sent successfully to ${msisdn}`, { statusCode: result.statusCode });
            return { success: true, message: result.message };
          }
        }
        op.fail(new Error(result.message || "send-pin rejected"), `OTP send rejected for ${msisdn}: ${result.message}`);
        return { success: false, message: result.message };
      }
      else {
        op.fail(new Error(`HTTP ${response.status}`), `OTP send failed for ${msisdn} (HTTP ${response.status})`);
        return { success: false, message: language === 'UZ' ? "PIN-kod yuborilmadi" : "Не удалось отправить PIN-код" };
      }
    }
    catch (error) {
      console.log(error);
      op.fail(error, `OTP send threw an error for ${msisdn}`);
      return { success: false, message: language === 'UZ' ? "PIN-kod yuborilmadi" : "Не удалось отправить PIN-код" };
    }
  }

  async verifyPin(endpoint, msisdn, otp, campaignId, language, trackerId, gclid, gbraid, wbraid, goalId, goalName, landingPageUrl, landingPageName, operatorId, yclid, clientId, userId) {
    const op = logger.startOperation(
      "verify_otp",
      "verifyPin",
      { msisdn, landingPageName, campaignId, trackerId },
      `Visitor submitted an OTP for number ${msisdn} on "${landingPageName}"`
    );
    try {
      const date = new Date();
      const formattedDateTime = format(date, "yyyy-MM-dd HH:mm:ssxxx");
      const baseUrl = process.env.REACT_APP_SUB_BASE_URL;
      const response = await fetch(baseUrl + endpoint, {
        method: 'POST',
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          msisdn: msisdn,
          lang: language === 'RU' ? 'ru-RU' : 'uz-UZ',
          channel: 'LANDING_PAGE',
          campaignId: campaignId,
          otp: otp,
          trackerId: trackerId,
          gclid: gclid,
          gbraid: gbraid,
          wbraid: wbraid,
          conversionDateTime: formattedDateTime,
          conversionGoalId: goalId,
          conversionGoalName: goalName,
          landingPageUrl: landingPageUrl,
          landingPageName: landingPageName,
          operatorId: operatorId,
          yclid: yclid,
          clientId: clientId,
          userId: userId,
        })
      });

      if (response.ok) {
        const result = await response.json();
        if (result.status) {
          op.success(`OTP verified successfully for ${msisdn}`);
          return { success: true, message: result.message };
        }
        op.fail(new Error(result.message || "verify-pin rejected"), `OTP verification rejected for ${msisdn}: ${result.message}`);
        return { success: false, message: result.message };
      }
      else {
        op.fail(new Error(`HTTP ${response.status}`), `OTP verification failed for ${msisdn} (HTTP ${response.status})`);
        return { success: false, message: language === 'UZ' ? "PIN kodni tekshirish amalga oshmadi" : "Проверка PIN-кода не удалась" };
      }
    }
    catch (error) {
      op.fail(error, `OTP verification threw an error for ${msisdn}`);
      return { success: false, message: language === 'UZ' ? "PIN kodni tekshirish amalga oshmadi" : "Проверка PIN-кода не удалась" };
    }
  }

  async subscribe(endpoint, msisdn, campaignId, language, trackerId, gclid, gbraid, wbraid, goalId, goalName, landingPageUrl, landingPageName, operatorId, deviceFingerprint, yclid, clientId, userId) {
    const op = logger.startOperation(
      "subscribe",
      "subscribe",
      { msisdn, landingPageName, campaignId, trackerId },
      `Visitor's subscription attempt for number ${msisdn} on "${landingPageName}"`
    );
    try {
      const date = new Date();
      const formattedDateTime = format(date, "yyyy-MM-dd HH:mm:ssxxx");
      const baseUrl = process.env.REACT_APP_SUB_BASE_URL;
      const response = await fetch(baseUrl + endpoint, {
        method: 'POST',
        // credentials: 'include',
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          msisdn: msisdn,
          lang: language === 'RU' ? 'ru-RU' : 'uz-UZ',
          channel: 'LANDING_PAGE',
          campaignId: campaignId,
          trackerId: trackerId,
          gclid: gclid,
          gbraid: gbraid,
          wbraid: wbraid,
          conversionDateTime: formattedDateTime,
          conversionGoalId: goalId,
          conversionGoalName: goalName,
          landingPageUrl: landingPageUrl,
          landingPageName: landingPageName,
          operatorId: operatorId,
          deviceFingerprint: deviceFingerprint,
          yclid: yclid,
          clientId: clientId,
          userId: userId,
        }),
      });

      if (response.ok) {
        const result = await response.json();
        if (result.status) {
          if (result.statusCode === 2003) {
            const data = result.data;
            op.success(`Subscription redirected (SMS) for ${msisdn}`, { statusCode: result.statusCode });
            return { success: true, message: result.message, redirectSms: data.redirectUr };
          }
          if (result.statusCode === 2004) {
            const data = result.data;
            op.success(`Subscription redirected (URL) for ${msisdn}`, { statusCode: result.statusCode });
            return { success: true, message: result.message, redirectUrl: data.url };
          }
          if (result.statusCode === 0) {
            op.success(`Subscription completed successfully for ${msisdn}`, { statusCode: result.statusCode });
            return { success: true, message: result.message };
          }
        }
        op.fail(new Error(result.message || "subscribe rejected"), `Subscription rejected for ${msisdn}: ${result.message}`);
        return { success: false, message: result.message };
      }
      else {
        op.fail(new Error(`HTTP ${response.status}`), `Subscription failed for ${msisdn} (HTTP ${response.status})`);
        return { success: false, httpStatus: response.status, message: language === 'UZ' ? "Obuna bo'lish amalga oshmadi" : "Подписка не удалась" };
      }
    }
    catch (error) {
      console.log(error);
      op.fail(error, `Subscription threw an error for ${msisdn}`);
      return { success: false, message: language === 'UZ' ? "Obuna bo'lish amalga oshmadi" : "Подписка не удалась" };
    }
  }

  async saveHistory(landingPageUrl, params) {
    try {
      let baseUrl = null;
      let endpoint = null;
      let extraParams = null;
      const isGoogleCampaign = params?.hasOwnProperty("gclid");
      if (isGoogleCampaign) {
        baseUrl = process.env.REACT_APP_GOOGLE_BASE_URL;
        endpoint = "google/visit";
        const list = ["gclid", "gbraid", "wbraid", "campaignId", "conversions", "cost_micros", "cpa", "utm_source", "utm_medium", "utm_campaign",
          "utm_term", "utm_content", "ad_group_id", "ad_group_name", "ad_id", "keyword_id", "keyword_text", "match_type", "clicks", "impressions",
          "ctr", "average_cpc", "conversion_date", "click_date", "geo_location", "device"];
        extraParams = Object.keys(params).reduce((acc, key) => {
          if (!list.includes(key)) {
            acc[key] = params[key];
          }
          return acc;
        }, {});
      }

      if (endpoint === null) {
        return;
      }

      await fetch(baseUrl + endpoint, {
        method: 'POST',
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          gclid: params.gclid,
          gbraid: params.gbraid,
          wbraid: params.wbraid,
          campaign: params.campaignId,
          conversions: params.conversions,
          costMicros: params.cost_micros,
          cpa: params.cpa,
          utmSource: params.utm_source,
          utmMedium: params.utm_medium,
          utmCampaign: params.utm_campaign,
          utmTerm: params.utm_term,
          utmContent: params.utm_content,
          adGroupId: params.ad_group_id,
          adGroupName: params.ad_group_name,
          adId: params.ad_id,
          keywordId: params.keyword_id,
          keywordText: params.keyword_text,
          matchType: params.match_type,
          clicks: params.clicks,
          impressions: params.impressions,
          ctr: params.ctr,
          averageCpc: params.average_cpc,
          conversionDate: params.conversion_date,
          clickDate: params.click_date,
          geoLocation: params.geo_location,
          device: params.device,
          landingPageUrl: landingPageUrl,
          extraParams: JSON.stringify(extraParams)
        })
      });
    }
    catch (error) {
      logger.warn("save_history", "saveHistory", "Saving Google campaign visit history failed", {
        error: error?.message || String(error),
      });
    }
  }
}

export default ApiSender;  